import React from 'react';
import Tabs from '../Tabs/Tabs';
import DataSourcePresenterWorkspace from './DataSourcePresenterWorkspace';

export default class DataSourcePresenter extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'general',
    };
    this.onChangeTab = this.onChangeTab.bind(this);
  };

  render() {
    return(
      <div ref="root" className = "panel panel-form">
        <Tabs tabs={this.tabs()} />
        <DataSourcePresenterWorkspace {...this.state} {...this.props} />
      </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('columns'),
          targetName: 'columns',
          classes: this.state.activeTab === 'columns' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
      ]
    );
  };

  onChangeTab(value, tab) {
    this.setState({
      activeTab: value,
    });
  };
};